/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, CollectorAdministratorFromJSON, CollectorAdministratorToJSON, CustomerFromJSON, CustomerToJSON, } from './';
export function ContactPersonFromJSON(json) {
    return ContactPersonFromJSONTyped(json, false);
}
export function ContactPersonFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'customer': !exists(json, 'customer') ? undefined : CustomerFromJSON(json['customer']),
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'collectorAdministratorId': !exists(json, 'collectorAdministratorId') ? undefined : json['collectorAdministratorId'],
        'collectorAdministrator': !exists(json, 'collectorAdministrator') ? undefined : CollectorAdministratorFromJSON(json['collectorAdministrator']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'additionalEmail': !exists(json, 'additionalEmail') ? undefined : json['additionalEmail'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'phoneNumberPrefix': !exists(json, 'phoneNumberPrefix') ? undefined : json['phoneNumberPrefix'],
        'additionalPhone': !exists(json, 'additionalPhone') ? undefined : json['additionalPhone'],
        'additionalPhoneNumberPrefix': !exists(json, 'additionalPhoneNumberPrefix') ? undefined : json['additionalPhoneNumberPrefix'],
        'isDefault': json['isDefault'],
        'isDeleted': json['isDeleted'],
        'isActive': json['isActive'],
    };
}
export function ContactPersonToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'customer': CustomerToJSON(value.customer),
        'customerId': value.customerId,
        'collectorAdministratorId': value.collectorAdministratorId,
        'collectorAdministrator': CollectorAdministratorToJSON(value.collectorAdministrator),
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'additionalEmail': value.additionalEmail,
        'phone': value.phone,
        'phoneNumberPrefix': value.phoneNumberPrefix,
        'additionalPhone': value.additionalPhone,
        'additionalPhoneNumberPrefix': value.additionalPhoneNumberPrefix,
        'isDefault': value.isDefault,
        'isDeleted': value.isDeleted,
        'isActive': value.isActive,
    };
}
